import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";
import {
  FaLock,
  FaBox,
  FaProjectDiagram,
  FaCode,
  FaCogs,
  FaBoxOpen,
  FaTrash,
} from "react-icons/fa";
import "../../assets/styles/ProductStyles/ProductsLayoutStyles/ProductsLayoutStyles.css";
import Unit_Icon from "../../assets/icons/Products_Layout_Icons/Unit_Setting.svg";
const ProductLayout = () => {
  const location = useLocation();

  return (
    <div>
      <div className="px-3 my-5 w-full font-inter">
        <h1 className="text-2xl mb-5   font-semibold text-[#667085]">
          Products
        </h1>
        <hr />
      </div>
      <div>
        <div className="flex gap-8">
          <NavLink
            to="all-products"
            className={({ isActive }) =>
              isActive ||
              location.pathname === "/admin-dashboard/product-module" ||
              location.pathname.startsWith(
                "/admin-dashboard/product-module/view-product"
              )
                ? "nav-link active-link flex justify-center items-center gap-1 lg:text-[14px] xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaLock /> All Product List
          </NavLink>
          <NavLink
            to="add-products"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaBox /> Add Product
          </NavLink>
          <NavLink
            to="category-management"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaProjectDiagram /> Category Management
          </NavLink>
          <NavLink
            to="hsn-management"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaCode /> HSN Management
          </NavLink>
          <NavLink
            to="unit-settings"
            className={({ isActive }) =>
              isActive
                ? "flex gap-1 nav-link active-link lg:text-[14px] justify-center items-center  xl:text-[16px]"
                : "flex gpa-1 nav-link lg:text-[14px]  justify-center items-center   xl:text-[16px]"
            }
          >
            <FaCogs /> Unit Settings
          </NavLink>
          <NavLink
            to="related-product-settings"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaBoxOpen /> Related Product Settings
          </NavLink>
          <NavLink
            to="product-trash"
            className={({ isActive }) =>
              isActive
                ? "nav-link active-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
                : "nav-link lg:text-[14px] flex justify-center items-center  gap-1 xl:text-[16px]"
            }
          >
            <FaTrash /> Trash
          </NavLink>
        </div>

        <div className="py-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProductLayout;
